import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Typography
} from '@mui/material';

const apiUrlReservas = process.env.REACT_APP_API_USUARIO_RESERVAS; // 🔹 Endpoint para traer reservas de un usuario específico

function ReservasUsuario() {
  const [reservas, setReservas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Obtener el usuario logueado desde localStorage
  const userData = JSON.parse(localStorage.getItem("user"));
  const usuarioId = userData?.id; // 📌 ID del usuario logueado

  useEffect(() => {
    if (!usuarioId) {
      setError("No se encontró un usuario logueado.");
      setLoading(false);
      return;
    }

    const fetchReservasUsuario = async () => {
      try {
        const response = await axios.get(`${apiUrlReservas}${usuarioId}`);
        setReservas(response.data);
      } catch (error) {
        console.error("❌ Error al obtener las reservas:", error);
        setError("No poseés ninguna reservas.");
      } finally {
        setLoading(false);
      }
    };

    fetchReservasUsuario();
  }, [usuarioId]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ mt: 2 }}>Cargando reservas...</Typography>
      </div>
    );
  }

  if (error) {
    return <Typography variant="body1" color="error">{error}</Typography>;
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>N° de reserva</TableCell>
            <TableCell>Fecha de Creación</TableCell>
            <TableCell>Fecha de Entrada</TableCell>
            <TableCell>Fecha de Salida</TableCell>
            <TableCell>Responsable</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reservas.length > 0 ? (
            reservas.map((reserva) => (
              <TableRow key={reserva.id}>
                <TableCell>{reserva.id}</TableCell>
                <TableCell>{reserva.createdAt}</TableCell>
                <TableCell>{reserva.fecha_entrada}</TableCell>
                <TableCell>{reserva.fecha_salida}</TableCell>
                <TableCell>{`${reserva.responsable_nombre} ${reserva.responsable_apellido}`}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} style={{ textAlign: "center" }}>
                No tienes reservas registradas.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ReservasUsuario;
